const initState = {
  sampling: 6,//抽样数
  eventNodes: "begin",
  userBehaiorPathData: {},
  isSelect: false,
  reset: false,
  userPathParams: {},
  checkAllGroup: []
};

const userHaviorPath = {
  state: initState,
  mutations: {
    SET_SAMPLING(state, value) {
      state.sampling = value;
    },
    SET_USERBEHAVIORPATH_DATA(state, value) {
      state.userBehaiorPathData = value;
    },
    SET_IS_SELECT(state, value) {
      state.isSelect = value;
    },
    SET_RESET(state, value) {
      state.reset = value;
    },
    SET_USER_PATH_PARAMS(state, params) {
      state.userPathParams = params;
    },
    SET_CHACK_ALL_GROUP(state, params) {
      state.checkAllGroup = params;
    },
    SET_EVENT_NODES(state, event) {
      state.eventNodes = event;
    },

  },
  getters: {},
  actions: {}
};

export default userHaviorPath;



// WEBPACK FOOTER //
// ./src/store/modules/user-behavior-path.js